import { alpha, SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = { marginY: 2 };

const table: SxProps<Theme> = { minWidth: 700 };

const header: SxProps<Theme> = (theme) => ({
  textTransform: 'uppercase',
  fontSize: 12,

  '&:hover': {
    color: alpha(theme.palette.primary.dark, 0.8),
  },

  '&.Mui-active': {
    color: theme.palette.primary.dark,
    textDecoration: 'underline',
    textDecorationColor: alpha(theme.palette.primary.dark, 0.4),
    textDecorationStyle: 'dashed',
    textUnderlineOffset: theme.spacing(0.5),
  },
});

const styles = {
  container,
  table,
  header,
};

export default styles;
